import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import SendIcon from "@mui/icons-material/Send";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { initAmplify, getSignedUrl } from "../utils/amplify";
import SettingsIcon from "@mui/icons-material/Settings";

initAmplify();

function FormGetTrx({ sharedValue }) {
  const [transactionId, setTransactionId] = useState("");
  const [creditorId, setCreditorId] = useState("100000001");
  const [trxStatus, setTrxStatus] = useState("");
  const [trxUpdated, setTrxUpdated] = useState("");
  const [trxDebtor, setTrxDebtor] = useState("");

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const [socketClosed, setSocketClosed] = useState(false);

  useEffect(() => {
    if (sharedValue) {
      setTransactionId(sharedValue);
    }
  }, [sharedValue]);

  function handleSubmit() {
    const body = {
      transactionId,
      creditor: {
        id: creditorId,
      },
    };

    getSignedUrl().then((signedUrl) => {
      let socketRef;
      if (signedUrl.length) {
        handleShow();
        console.log(signedUrl);
        socketRef = new WebSocket(`${signedUrl}&validation=false`);
        if (socketClosed && socketRef) {
          setSocketClosed(false);
        }

        try {
          socketRef.onopen = () => {
            // Send data through the WebSocket after the connection is established and the $connect event has returned a 200 status code
            if (socketRef && socketRef.readyState === WebSocket.OPEN) {
              socketRef?.send(JSON.stringify(body));
            }
          };
        } catch (e) {
          handleClose();
          console.error(
            "An error occured initializing the transaction creation:",
            e
          );
        }

        // need to handle this still
        socketRef.onerror = (event) => {
          handleClose();
          console.error("A general error occurred with the WebSocket:", event);
        };

        // wait for message from ITT
        socketRef.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            setTrxDebtor(message?.trxDebtor);
            setTrxStatus(message?.trxStatus);
            setTrxUpdated(message?.trxUpdated);
            socketRef.close();
          } catch (e) {
            handleClose();
            console.error("An error occurred while parsing the message:", e);
          }
        };

        socketRef.onclose = (event) => {
          console.log("Closing...");
          handleClose();
          setSocketClosed(true);
        };
      }
    });
  }

  return (
    <Container fluid style={{ width: 70 + "%" }}>
      <div>
        <span label="Get Transaction">
          <Typography variant="h3" gutterBottom>
            Transaction Status
          </Typography>
        </span>
      </div>
      <div className="div-margin">
        <Row>
          <Col>
            <TextField
              size="small"
              id="transactionId"
              label="Transaction ID"
              type="text"
              fullWidth
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </Col>
          <Col>
            <TextField
              size="small"
              id="creditorId"
              label="Creditor Id"
              type="text"
              value={creditorId}
              fullWidth
              onChange={(e) => setCreditorId(e.target.value)}
            />
          </Col>
        </Row>
      </div>
      <div className="div-margin">
        <Row>
          <Col>
            <Typography variant="body1" gutterBottom>
              Transaction ID: {transactionId}
            </Typography>
          </Col>
          <Col>
            <Typography variant="body1" gutterBottom>
              Status: {trxStatus}
            </Typography>
          </Col>
          <Col>
            <Typography variant="body1" gutterBottom>
              Updated: {trxUpdated}
            </Typography>
          </Col>
          <Col>
            <Typography variant="body1" gutterBottom>
              Debtor Id: {trxDebtor}
            </Typography>
          </Col>
        </Row>
      </div>

      <Row style={{ paddingBottom: "3%" }}>
        <Col md="3"></Col>
        <Col md="3">
          <Button
            variant="contained"
            onClick={handleSubmit}
            endIcon={<SendIcon />}
            color="primary"
          >
            Submit
          </Button>
        </Col>
        <Col md="3"></Col>
      </Row>

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body style={{ textAlign: "center" }}>
          <Typography variant="h4">
            Retrieving transaction status...{" "}
          </Typography>
          <br />
          <SettingsIcon className="image" fontSize="large" />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default FormGetTrx;
